import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SectionModel} from '@app/models/section';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {FormGroup} from '@angular/forms';
import {formly, formlyRow} from '@shared/helper/formly-helpers';
import {CourseService} from '@app/@core/services/course.service';
import {AppService} from '@shared/services/app.service';
import {TicketService} from '@app/@core/services/ticket.service';
import Section = SectionModel.Section;
import Card = SectionModel.Card;
import {PackageInfoService} from "@app/@core/services/package-info.service";
import {LeisureShopService} from "@app/@core/services/leisure-shop.service";

export interface IButton {
  title?: string;
  imageUrl?: string;
  route?: string;
}

@Component({
  selector: 'app-carousel-editor',
  templateUrl: './carousel-editor.component.html',
  styleUrls: ['./carousel-editor.component.css']
})
export class CarouselEditorComponent implements OnInit {
  @Input() section: Section;
  @Input() listType: 'CAROUSEL' | 'BUCKET';
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onSave = new EventEmitter<Section>();

  selectedCourse: string[];
  selectedTicket: string[];
  selectedPackageInfo: string[];

  newButton: IButton = {};

  displayEditCard = false;
  editCard: Card;

  formGroup = new FormGroup({});

  fields: FormlyFieldConfig[] = [];

  courseOptions$ = this.courseService.groupedOptions$;
  ticketOptions$ = this.ticketService.groupedOptions$;
  packageOptions$ = this.packageInfoService.groupedOptions$;
  shopOptions$ = this.leisureShopService.groupedOptions$;

  constructor(private app: AppService,
              private ticketService: TicketService,
              private courseService: CourseService,
              private leisureShopService: LeisureShopService,
              private packageInfoService: PackageInfoService) {
  }

  ngOnInit() {
    this.leisureShopService.fetchAllName().subscribe(res => {
    });
    if (this.section.type === 'BUCKET') {
      this.fields = [
        formly.text('title', 'Title'),
        formly.text('subtitle', 'Subtitle'),
        formly.boolean('showSlot', 'Show Slot'),
        formly.boolean('showHotdeal', 'Show Hotdeal'),
        formly.text('seeMoreText', 'SeeMoreText'),
      ];
    } else {
      this.fields = [
        formly.text('title', 'Title'),
        formly.boolean('showSlot', 'Show Slot'),
        formly.boolean('showHotdeal', 'Show Hotdeal'),
      ];
    }

    this.ticketService.groupedOptions$.subscribe((data) => {
      console.log('ticketService data', data);
    });

    this.courseService.groupedOptions$.subscribe((data) => {
      console.log('courseService data', data);
    });

    this.packageInfoService.groupedOptions$.subscribe((data) => {
      console.log('packageInfoService data', data); // Log PackageInfo grouped options
    });
    this.leisureShopService.groupedOptions$.subscribe((data) => {
      console.log('leisureShopService data', data);
    });

  }

  addCourses() {
    this.selectedCourse.forEach(id => {
      const name = this.courseService.getName(id);
      this.push({id, route: id, title: name, type: 'COURSE'});
    });
    this.selectedCourse = [];
  }

  addTickets() {
    this.selectedTicket.forEach(id => {
      const name = this.ticketService.getName(id);
      this.push({route: id, title: name, type: 'LEISURE'});
    });

    this.selectedTicket = [];
  }

  addPackageInfo() {
    this.selectedPackageInfo.forEach(id => {
      const name = this.packageInfoService.getName(id);
      this.push({route: id, title: name, type: 'PACKAGE'});
    });

    this.selectedPackageInfo = [];
  }

  private push(card: Card) {
    const isExist = this.section.cards.find(c => c.route === card.route);
    if (!isExist) {
      this.section.cards = [...this.section.cards, card];
    } else {
      this.app.toastAlert('Already exist', 'This item already exist in the list');
    }
  }

  addButton() {
    this.section.cards = [...this.section.cards, {
      title: this.newButton.title,
      route: this.newButton.route,
      imageUrl: this.newButton.imageUrl,
      type: 'BUTTON'
    }];

    this.newButton = {};
  }

  deleteAll() {
    this.section.cards = [];
  }

  edit(card: Card) {
    this.displayEditCard = true;
    this.editCard = card;
  }

  delete(card: Card) {
    this.section.cards = [...this.section.cards.filter(c => c.route !== card.route)];
  }

  save() {
    this.onSave.emit(this.section);
  }
}
